export const ACCOUNT_DATE_FORMATS = {
  variant1: 'dd-MM-yyyy HH:mm:ss',
  variant2: 'yyyy-MM-dd HH:mm:ss',
  variant3: 'MM-dd-yyyy HH:mm:ss',
  variant4: 'dd-MM-yyyy hh:mm:ss a',
  variant5: 'yyyy-MM-dd hh:mm:ss a',
  variant6: 'MM-dd-yyyy hh:mm:ss a',
} as const;
